module.exports = __webpack_public_path__ + "img/Recipe-365DingKang.4b54b38d.png";